import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CallbackResult, CallbackResultStatus, StandardColorRed } from '../../../../../../../utils';
import { Association, AssociationAlert } from '../../../../../../../models/association';
import { AssociationService } from '../../../../../../../services/association/association.service';

@Component({
  selector: 'app-add-association-alert-modal',
  templateUrl: './add-association-alert-modal.component.html',
  styleUrls: ['./add-association-alert-modal.component.css']
})
export class AddAssociationAlertModalComponent {

  @Input() association: Association;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public associationAlert: AssociationAlert = {
    id: null,
    url: '',
    alert_text: '',
    expiry_date: '',
    color_hex: StandardColorRed.colorHex,
    created_by_id: null,
    created_by_email: '',
    updated_by_id: null,
    updated_by_email: '',
    created_date: '',
    updated_date: '',
    created_at: '',
    updated_at: ''
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public associationService: AssociationService
  ) {}

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.associationService
      .addAssociationAlert(
        this.association.id,
        this.associationAlert
      )
      .then(createdAlert => {
        this.savedCallback({
          text: 'Alert created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create association alerts.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
